import styled from 'styled-components';

/**
 * Capped and scrolling, so "Show more" grows the list inside the card instead
 * of pushing the viewers table further down beside a chart that stays put.
 */
export const ActivityList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 260px;
  overflow-y: auto;
`;

/** One event. A hairline between rows, none above the first. */
export const ActivityRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;

  & + & {
    border-top: 1px solid ${({ theme }) => theme.gray};
  }
`;

/** The sentence takes what is left; the time never wraps under it. */
export const ActivityText = styled.p`
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.darkGray};
`;
